
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton, AppInput, AppSelect, AppFormRow, AppCheckbox } from '@/components';
import { useAvatarItemList } from '@/modules/avatar/item/model/list';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.ITEM.INDEX,
    components: { AppTable, AppCard, AppButton, AppInput, AppSelect, AppFormRow, AppCheckbox },
    setup() {
        const { v$, query, list, total, fetchList, actions, bundleSelection, BUNDLE_LINK_MODAL_NAME } =
            useAvatarItemList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Boolean, label: 'Is published', key: 'isPublished' },
                { type: TableColumnType.Boolean, label: 'Is new', key: 'isNew' },
                { type: TableColumnType.Boolean, label: 'Is default', key: 'isDefault' },
                { type: TableColumnType.Boolean, label: 'Is special', key: 'isSpecial' },
                { type: TableColumnType.Text, label: 'Total sale', key: 'totalSale' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_AVATAR.ITEM.EDIT, params: { itemId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-image',
                        theme: 'info',
                        tooltip: 'View images',
                        to: { name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: row.id } }
                    }),
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-link',
                        theme: 'success',
                        tooltip: 'Link bundle',
                        onClick: () => actions.openLinkBundle(row.id)
                    }),
                    group: 3
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            v$,
            table,
            list,
            total,
            query,
            fetchList,
            actions,
            IsNewOptions,
            bundleSelection,
            BUNDLE_LINK_MODAL_NAME,
            ROUTE_NAME_AVATAR
        };
    }
});

const IsNewOptions = [
    { label: 'Not specified', value: '' },
    { label: 'No', value: 'false' },
    { label: 'Yes', value: 'true' }
];
